import TUIRoomEngine__default from "@tencentcloud/tuiroom-engine-js";
import useGetRoomEngine from "./useRoomEngine.mjs";
import MessageBox from "../components/common/base/MessageBox/index.mjs";
import { useI18n } from "../locales/index.mjs";
const roomEngine = useGetRoomEngine();
let isShowAutoPlayDialog = false;
function useCustomizedAutoPlayDialog() {
  const { t } = useI18n();
  TUIRoomEngine__default.once("ready", () => {
    var _a;
    const trtcCloud = (_a = roomEngine.instance) == null ? void 0 : _a.getTRTCCloud();
    trtcCloud.callExperimentalAPI(
      JSON.stringify({
        api: "enableAutoPlayDialog",
        params: { enable: 0 }
      })
    );
    trtcCloud.on("onAutoPlayFailed", () => {
      if (!isShowAutoPlayDialog) {
        isShowAutoPlayDialog = true;
        MessageBox({
          title: t("Attention"),
          message: t(
            'Audio playback failed. Click the "Confirm" to resume playback'
          ),
          confirmButtonText: t("Confirm"),
          callback: () => {
            isShowAutoPlayDialog = false;
          }
        });
      }
    });
  });
}
export {
  useCustomizedAutoPlayDialog as default
};
